module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.c576f4f3.png";